export const USERNAME = "USERNAME";
export const TOKEN = "TOKEN";
export const CLEAR = "CLEAR";
export const STATUS = "STATUS";
export const LINE_GRAPH = "LINE_GRAPH";
export const GRAPH_LABEL = "GRAPH_LABEL";
